;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/KalturaVideo',["jquery", "eventManager", 'loglevel'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('loglevel')) :
    console && console.error('Kaltura Video does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log) {

    function KalturaVideo(scope, targetId, wid, uiconfid, videoId, autoPlay, allowFullScreen, closedCaptions, stateChangeMessages, onPlayMessagesPerformer, onPauseMessagePerformer) {
        ///<summary>Initialize a new instance of KalturaVideo. Subscribe to messages which are passed to current instance.</summary>

        var self = this, instance = {};
        instance.stateChangeMessages = stateChangeMessages.slice();
        
        Object.defineProperties(this, {
            scope: { enumerable: true, value: scope },
            $scope: { enumerable: true, value: $(scope) },
            stateChangeMessages: {
                enumerable: true,
                get: function () {
                    return instance.stateChangeMessages.slice();
                }
            },
            trackPlayStartTimeout: {
                enumerable: !1,
                value: void 0,
                writable: !0
            },
            trackTimelineInterval: {
                enumerable: !1,
                value: void 0,
                writable: !0,
            },
            currentTime: {
                enumerable: !1,
                get: function() {
                    return this.player ? Math.floor(this.player.evaluate('{video.player.currentTime}')) : void 0;
                }
            }
        });
        
        this.addStateChangeMessage = function addStateChangeMessage(message) {
            if (!message) return;
            if (instance.stateChangeMessages.indexOf(message) > -1) {
                log.debug("Component is already registered for event " + message);
                return;
            }
            
            instance.stateChangeMessages.push(String(message));
        };

        //#region play message performer
        if (onPlayMessagesPerformer.length) {
            onPlayMessagesPerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.play, self);
            });
        }
        //#endregion

        //#region show messages performer
        if (onPauseMessagePerformer.length) {
            onPauseMessagePerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.pause, self);
            });
        }
        //#endregion
        
        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }

        Object.defineProperties(this,
            {
                videoId: { enumerable: !1, value: videoId },
                player: { enumerable: !1, value: void 0, writable: !0 }
            });

        var flashVars = { // flashvars allows you to set runtime uiVar configuration overrides. 
            'autoPlay': !!autoPlay,
            'autoMute': !!autoPlay
        }

        if (!!closedCaptions) {
            flashVars.closedCaptions = {
                'hideWhenEmpty': true
            };
        }

        kWidget.embed({
            'targetId': targetId,
            'wid': wid,
            'uiconf_id': uiconfid,
            'entry_id' : videoId,
            'flashvars': flashVars,
            'params':{ // params allows you to set flash embed params such as wmode, allowFullScreen etc
                    'wmode': 'transparent'
            },
            'readyCallback' : (function(playerId) {
                var player = document.querySelector('#' + playerId);
                this.player = player;
                //this.player.kBind('playerPlayed', this._onPlayHandler.bind(this));
                this.player.kBind('playerPaused', this._onPauseHandler.bind(this));
                this.player.kBind('playerPlayEnd', this._onEndedHandler.bind(this));
                this.player.kBind('playerStateChange', this._onStateChange.bind(this));

            }).bind(this)
        });

        mw.setConfig('EmbedPlayer.EnableFullscreen', !!allowFullScreen);
    }

    KalturaVideo.prototype._onStateChange = function (playerState) {
        if (playerState === 'playing') {
            this._onPlayHandler();
        }
    }
    KalturaVideo.prototype._onPlayHandler = function () {
        if (this.currentTime === 0) {
            $(this).trigger('start.video', [this.currentTime]);
        }

        $(this).trigger('update.timeline', [this.currentTime]);
        this.startTrackTimeline();
    }

    KalturaVideo.prototype._onPauseHandler = function () {
        this.stopTrackTimeline();
        if (Math.floor(this.player.evaluate('{duration}')) != this.currentTime) {
            $(this).trigger('pause.video', [this.currentTime]);
        }
    }

    KalturaVideo.prototype._onEndedHandler = function () {
        this.stopTrackTimeline();
        $(this).trigger('end.video', [this.currentTime]);
    }

    KalturaVideo.prototype.startTrackTimeline = function () {
        if (this.trackTimelineInterval) {
            clearInterval(this.trackTimelineInterval);
        }

        this.trackTimelineInterval = setInterval((function () {
            $(this).trigger('update.timeline', [this.currentTime]);
        }).bind(this), 1000 /* 1 second */);

        $(this).trigger('update.timeline', [this.currentTime]);
    }

    KalturaVideo.prototype.stopTrackTimeline = function () {
        if (this.trackTimelineInterval) {
            clearInterval(this.trackTimelineInterval);
        }
    }

    KalturaVideo.prototype.play = function () {
        ///<summary>Start playing the video.</summary>
        var kdp = this.$scope.find('.kaltura-wrapper')[0];
        kdp.sendNotification("doPlay");
        this.transmitStateChange();
    }

    KalturaVideo.prototype.pause = function () {
        ///<summary>Put the video on pause.</summary>
        var kdp = this.$scope.find('.kaltura-wrapper')[0];
        kdp.sendNotification("doPause");
        this.transmitStateChange();
    }

    KalturaVideo.prototype.transmitStateChange = function () {
        var messages = this.stateChangeMessages, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self, self.player);
            });
        }

    }
    // #endregion

    KalturaVideo.init = function init(args) {
        if (args.IsEditorEditing) return null;

        var video = new KalturaVideo(args.scope, args.targetId, args.wid, args.uiconfid, args.videoId, args.autoPlay, args.allowFullScreen, args.closedCaptions,
            args.StateChangeMessagesTransmitting || [],
            args.PlayActionMessages || [],
            args.PauseActionMessages || []);

        return video;
    };

    //requireJS load handler - used for passing Kaltura PartnerId and Kaltura UiConf Id kto require module definition
    KalturaVideo.load = function (name, req, onLoad) {
        if (!name || name.length <= 0) {
            log.error("Cannot load Kaltura API, please specify KalturaParnerId and KalturaUiConfId");
            return;
        }

        var nameParts = name.split('|');

        var partnerId = nameParts[0];
        var uiConfId = nameParts[1];

        // load kaltura deps with google key
        require(["//cdnapi.kaltura.com/p/" + partnerId + "/sp/" + partnerId + "00/embedIframeJs/uiconf_id/" + uiConfId + "/partner_id/" + partnerId], function () {
            onLoad(KalturaVideo);
        });
    }

    return KalturaVideo;
}));
